import { Flex, FloraTypography } from '@grupoboticario/flora-react'
import { InformationCircleIcon } from '@grupoboticario/flora-react-icons'

import { CAMPAIGN_MULTIPLIER_VALUES } from '@/constants/accelerationTable'

interface MultiplierCalculationExampleProps {
  multiplier: string
}

const MultiplierCalculationExample = ({ multiplier }: MultiplierCalculationExampleProps) => {
  const selectedMultiplier = CAMPAIGN_MULTIPLIER_VALUES.find((item) => item.value.toString() === multiplier)

  if (!selectedMultiplier) return null

  const basePoints = 100
  const bonusPoints = basePoints * selectedMultiplier.value
  const totalPoints = basePoints + bonusPoints

  return (
    <Flex
      gap="$2"
      css={{
        backgroundColor: '$backgroundSecondary',
        borderRadius: '$medium',
        padding: '$3 $6'
      }}
    >
      <InformationCircleIcon color="$nonInteractiveAuxiliar" size={18} css={{ flexShrink: 0, marginTop: '$1' }} />
      <Flex direction="column" gap="$1" css={{ marginTop: '$1', color: '$nonInteractiveAuxiliar' }}>
        <FloraTypography fontSize="exceptionsAuxiliar" fontWeight="medium">
          Como calcular (exemplo):
        </FloraTypography>
        <FloraTypography fontSize="exceptionsAuxiliar">Compra R$100,00 = 100 pontos</FloraTypography>
        <FloraTypography fontSize="exceptionsAuxiliar">
          {selectedMultiplier.label} = + {bonusPoints} pontos
        </FloraTypography>
        <FloraTypography fontSize="exceptionsAuxiliar">
          Total que o consumidor ganha = {totalPoints} pontos
        </FloraTypography>
      </Flex>
    </Flex>
  )
}

export default MultiplierCalculationExample
